import { IAttribute, IAttributeValueOption } from "../../../services/attribute-data-service/Models";


const AttributeSchemaObjectUtils = {
    
    filter: (data: IAttribute[], 
        objectFilter: string,
        optionsFilter: IAttributeValueOption[]
    ) : IAttribute[] => {

        let items = data.filter(o => o.odt.toLowerCase().indexOf(objectFilter.trim().toLowerCase()) !== -1 || objectFilter.trim() === '');

        if (optionsFilter.length > 0) {
            items = items.filter(o => optionsFilter.find(v => v.value === o.avalt) !== undefined);
        }

        return items;

    }
}

export default AttributeSchemaObjectUtils;